import { authPost } from './authMiddleware';

export const postPropertyProvinces = (data) => {
    return authPost(`/api/property/province?CountryName=${data}`);
}